import { useEffect } from 'react';
import Router from './routes';
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';
import { ToastContainer } from 'react-toastify';
import { feathersClient } from './client';
import { useAppDispatch } from './store';
import { logoutUserFromLoacal } from './store/auth/authSlice';
import { ConfirmProvider } from 'material-ui-confirm';
import CloseIcon from '@mui/icons-material/Close';
import { Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
// import { useNavigate } from 'react-router-dom';

const App = () => {
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();

  useEffect(() => {
    feathersClient.reAuthenticate().catch(() => {
      dispatch(logoutUserFromLoacal());
    });
  }, [dispatch]);

  return (
    <ThemeConfig>
      <ScrollToTop />
      <GlobalStyles />
      <BaseOptionChartStyle />
      <ConfirmProvider
        defaultOptions={{
          confirmationButtonProps: {
            variant: 'contained',
            sx: { marginBottom: '8px', marginRight: '8px' },
          },
          confirmationText: 'Yes',
          cancellationButtonProps: {
            sx: { position: 'absolute', top: '8px', right: '0' },
          },
          cancellationText: <CloseIcon sx={{ color: '#9f9f9f' }}></CloseIcon>,
        }}
      >
        <Router />
      </ConfirmProvider>
      <ToastContainer
        position='top-right'
        autoClose={3000}
        newestOnTop={false}
        closeOnClick
        theme='colored'
        rtl={false}
        pauseOnFocusLoss
        draggable
        transition={Slide}
        pauseOnHover
      />
    </ThemeConfig>
  );
};
export default App;
